import { Box, Grid, Typography, Container, Stack } from "@mui/material";

import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import { useEffect, useState } from "react";
import SchoolLeaderboardSection from "../../sections/schooLeaderboard/SchoolLeaderboardSection.js";
import { getStoredAccountOrgID } from "../../helper/AccountHelper.js";
import { AdminApi } from "../../api/AdminApi";

export default function UserYearLeaderboardPage({ }) {
  const navigate = useNavigate();
  
  let storedOrgID = getStoredAccountOrgID();


  // Get event id from url

  // const { state } = useLocation();
  // const event = state?.event;

  // const orgType = getStoredAccountOrgType();


  return (
    <Container maxWidth="lg">
      <Stack direction="column" spacing={2} sx={{ mb: 5 }}>
        <Typography variant="h3">School Leaderboard</Typography>

        {
          (storedOrgID === 0) &&
          <Typography variant="h6" color="error">No organization ID found in your account. Please contact admin.</Typography>
        }


        {
          (storedOrgID !== 0) &&
          <SchoolLeaderboardSection orgID={storedOrgID} />

        }



      </Stack>
    </Container>
  );
}
